module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "right": "",
      "clipped": "",
      "persistent": "",
      "mobile-breakpoint": "800"
    },
    model: {
      value: (_vm.showDrawer),
      callback: function($$v) {
        _vm.showDrawer = $$v
      },
      expression: "showDrawer"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-xs": ""
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": "",
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showDrawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Metadata")])], 1), _vm._v(" "), (_vm.canModify) ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "success",
      "dark": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save"), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("create")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.formatTime(_vm.properties.timestamp),
      "prepend-icon": "watch_later",
      "hide-details": "",
      "readonly": ""
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.userInfo.username) ? _c('v-text-field', {
    attrs: {
      "value": _vm.userInfo.username.toLowerCase(),
      "hide-details": "",
      "label": "Uploader",
      "prepend-icon": "account_circle",
      "readonly": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.formatTime(_vm.properties.timeCreated),
      "hide-details": "",
      "label": "Upload Date",
      "prepend-icon": "mdi-weather-cloudy-clock",
      "readonly": ""
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.properties.location) ? _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Latitude",
      "prepend-icon": "gps_fixed",
      "readonly": ""
    },
    on: {
      "click:prepend": function($event) {
        return _vm.openMaps(_vm.location)
      }
    },
    model: {
      value: (_vm.properties.location.coordinates[1]),
      callback: function($$v) {
        _vm.$set(_vm.properties.location.coordinates, 1, $$v)
      },
      expression: "properties.location.coordinates[1]"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.properties.location) ? _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": "Longitude",
      "prepend-icon": "gps_fixed",
      "readonly": ""
    },
    on: {
      "click:prepend": function($event) {
        return _vm.openMaps(_vm.location)
      }
    },
    model: {
      value: (_vm.properties.location.coordinates[0]),
      callback: function($$v) {
        _vm.$set(_vm.properties.location.coordinates, 0, $$v)
      },
      expression: "properties.location.coordinates[0]"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.getCategories,
      "item-text": "name",
      "item-value": "id",
      "label": "Categories",
      "return-object": "",
      "hide-details": "",
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "hide-selected": ""
    },
    model: {
      value: (_vm.properties.categories),
      callback: function($$v) {
        _vm.$set(_vm.properties, "categories", $$v)
      },
      expression: "properties.categories"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-combobox', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "multiple": "",
      "label": "Tags",
      "items": _vm.getTags,
      "chips": "",
      "deletable-chips": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.properties.tags),
      callback: function($$v) {
        _vm.$set(_vm.properties, "tags", $$v)
      },
      expression: "properties.tags"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    staticStyle: {
      "margin-top": "8px",
      "padding-top": "8px"
    },
    attrs: {
      "auto-grow": "",
      "hide-details": "",
      "label": "Comment",
      "outline": ""
    },
    model: {
      value: (_vm.properties.annotation),
      callback: function($$v) {
        _vm.$set(_vm.properties, "annotation", $$v)
      },
      expression: "properties.annotation"
    }
  })], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-group', {
    attrs: {
      "value": false
    }
  }, [_c('v-list-item', {
    staticClass: "meta",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("More Information")])], 1)], 1), _vm._v(" "), _vm._l((_vm.infoArray), function(item) {
    return _c('v-col', {
      key: item.title,
      attrs: {
        "cols": "12"
      }
    }, [(item.title) ? _c('v-text-field', {
      staticClass: "more-info",
      attrs: {
        "dense": "",
        "hide-details": "",
        "label": item.value.charAt(0).toUpperCase() + item.value.slice(1),
        "readonly": ""
      },
      model: {
        value: (item.title),
        callback: function($$v) {
          _vm.$set(item, "title", $$v)
        },
        expression: "item.title"
      }
    }) : _vm._e()], 1)
  })], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-card', [_c('div', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.handleNav('exit')
            }
          }
        }, on), [_c('v-icon', [_vm._v("arrow_back")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Exit")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.canDelete) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showDeleteDialog = true
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("delete")])], 1)]
      }
    }], null, false, 2307193618)
  }, [_vm._v(" "), _c('span', [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "download": "",
            "href": _vm.downloadLink,
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("get_app")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Download")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "text": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showDrawer = !_vm.showDrawer
            }
          }
        }, on), [_c('v-icon', [_vm._v("info")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Show Metadata")])])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "lrg-image"
    }
  }, [(_vm.canNavRight) ? _c('div', {
    attrs: {
      "id": "right-button-area"
    },
    on: {
      "click": function($event) {
        return _vm.handleNav('right')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "right-button"
    }
  }, [_c('v-btn', {
    style: (("background-color: " + _vm.navColor + ";")),
    attrs: {
      "fab": ""
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.canNavLeft) ? _c('div', {
    attrs: {
      "id": "left-button-area"
    },
    on: {
      "click": function($event) {
        return _vm.handleNav('left')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "left-button"
    }
  }, [_c('v-btn', {
    style: (("background-color: " + _vm.navColor + ";")),
    attrs: {
      "fab": ""
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('img', {
    ref: "image",
    attrs: {
      "id": "main-img",
      "src": _vm.imageUrl,
      "alt": "Loading..."
    },
    on: {
      "load": _vm.handleImageLoad
    }
  })])])], 1), _vm._v(" "), _c('error-snackbar', {
    model: {
      value: (_vm.errorText),
      callback: function($$v) {
        _vm.errorText = $$v
      },
      expression: "errorText"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete this image?  This action cannot be undone.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDeleteDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteFile.apply(null, arguments)
      }
    }
  }, [_vm._v("I'm Sure")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.showChangesDialog),
      callback: function($$v) {
        _vm.showChangesDialog = $$v
      },
      expression: "showChangesDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "unsaved-text",
    staticStyle: {
      "font-size": "1em",
      "text-align": "center",
      "white-space": "pre-line",
      "word-break": "break-word"
    }
  }, [_c('p', [_vm._v("Unsaved Changes Exist")])]), _vm._v(" "), _c('v-card-subtitle', [_c('p', [_vm._v("Would you like to "), _c('b', [_vm._v("discard")]), _vm._v(" or "), _c('b', [_vm._v("save")]), _vm._v(" those changes?")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "error",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleNav('discard')
      }
    }
  }, [_vm._v("Discard")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save"), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("create")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-356dc45f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Image.vue
// module id = 423
// module chunks = 1